import { TranslationRepository } from '../data/translation-repository';
import { PublishResult, ApplicationType, S3Environment } from '../types/translation-types';

export class PublishTranslationsUseCase {
  constructor(private readonly repository: TranslationRepository) {}

  async execute(
    applicationType: ApplicationType,
    environment: S3Environment,
    notes?: string
  ): Promise<PublishResult> {
    return this.repository.publish(applicationType, environment, notes);
  }
}
